import type { VoidFunctionComponent } from 'react';

import { FormatSelector } from '../components/FormatSelector';
import { Heading } from '../components/Heading';
import PreviewFiltersLayout from '../layout/PreviewFiltersLayout';

import { VulnerabilityGenerateButton } from './VulnerabilityGenerateButton';
import { VulnerabilityPreview } from './VulnerabilityPreview';

/**
 * Dedicated page component for the Vulnerability report.
 * Even simpler than the Remediation Guidance page:
 * - No flow selector (Standard/Custom)
 * - No step headings
 * - No options panel or divider (vulnerability supports no customization)
 * - Format is locked to PDF via the shared FormatSelector auto-lock behaviour
 *
 * @deprecated The Security/Vulnerability report is a legacy surface gated by
 * the `SECURITY_PDF_REPORTS` feature flag. This report format is no longer
 * supported and is being phased out — do not add new functionality to this
 * component or extend its behaviour. New reporting work should target the
 * Remediation Guidance report (or successor) instead.
 */
export const VulnerabilityPage: VoidFunctionComponent = () => (
  <main className="padding-left-sm">
    <Heading />
    <PreviewFiltersLayout>
      <PreviewFiltersLayout.Preview>
        <VulnerabilityPreview />
      </PreviewFiltersLayout.Preview>
      <PreviewFiltersLayout.Filters>
        <div>
          <FormatSelector />
          <VulnerabilityGenerateButton />
        </div>
      </PreviewFiltersLayout.Filters>
    </PreviewFiltersLayout>
  </main>
);
